import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Item } from '../helper';

interface DropdownComponentProps {
    sitesDropdownData: Item[];
    projectsDropdownData: Item[];
    workpacksDropdownData: Item[];
    setSelectedSite: (item: Item) => void;
    setSelectedProject: (item: Item) => void;
    setSelectedWorkpack: (item: Item) => void;
    selectedSite: any;
    selectedProject: any;
    selectedWorkpack: any;
    isSitesLoading: boolean;
    isProjectsLoading: boolean;
    isWorkpacksLoading: boolean;
}

const Dropdowns: React.FC<DropdownComponentProps> = ({
    sitesDropdownData,
    projectsDropdownData,
    workpacksDropdownData,
    setSelectedSite,
    setSelectedProject,
    setSelectedWorkpack,
    selectedSite,
    selectedProject,
    selectedWorkpack,
    isSitesLoading,
    isProjectsLoading,
    isWorkpacksLoading
}) => {
    return (
        <div className="m-4 flex justify-content-between flex-wrap">
            <div className="flex align-items-center justify-content-center ">
                <Dropdown
                    value={selectedSite}
                    options={sitesDropdownData}
                    filter
                    loading={isSitesLoading}
                    optionLabel="name"
                    onChange={(e) => setSelectedSite(e.value)}
                    className="custom-ellipsis-dropdown"
                    placeholder="Select a Site"
                />
            </div>

            <div className="flex align-items-center justify-content-center">
                <Dropdown
                    value={selectedProject}
                    options={projectsDropdownData}
                    filter
                    loading={isProjectsLoading}
                    optionLabel="name"
                    onChange={(e) => setSelectedProject(e.value)}
                    className="custom-ellipsis-dropdown"
                    placeholder="Select a Project"
                />

            </div>

            <div className="flex align-items-center justify-content-center">
                <Dropdown
                    value={selectedWorkpack}
                    options={workpacksDropdownData}
                    filter
                    showClear
                    loading={isWorkpacksLoading}
                    optionLabel="name"
                    onChange={(e) => setSelectedWorkpack(e.value)}
                    className="custom-ellipsis-dropdown"
                    placeholder="Select a Workpack"
                />
            </div>
        </div>
    );
};

export default Dropdowns;